import { gql } from 'graphql-request';
import type { QueryFunctionContext } from 'react-query';

import { requestWithAuth } from '@/utilities/graphQLClient';

import {
  WATCHLIST_FRAGMENT,
  WATCHLIST_ITEM_FRAGMENT,
} from './watchlist-fragment';
import type {
  WatchlistFragmentType,
  WatchlistItemFragmentType,
} from './watchlist-fragment';

import {
  getDefaultResponse,
  mapWatchlistResponseToCache,
} from './mapWatchlistResponseToCache';

export interface QueryResponse {
  errors?: Error[];
  Watchlist:
    | (WatchlistFragmentType & {
        items: WatchlistItemFragmentType[];
      })
    | undefined;
}

export const queryFn = async ({
  queryKey: [, id],
}: QueryFunctionContext<[string, string | null | undefined]>) => {
  if (typeof id === 'undefined') {
    throw new Error(`Cannot fetch Watchlist for id ${id}`);
  }
  const response = await requestWithAuth<QueryResponse>(
    gql`
      query getWatchlist($id: String) {
        Watchlist(id: $id) {
          ...watchlistFields
          items {
            ...watchlistItemFields
          }
        }
      }
      ${WATCHLIST_FRAGMENT}
      ${WATCHLIST_ITEM_FRAGMENT}
    `,
    { id }
  );
  const { Watchlist, errors } = response;
  if (errors && errors.length > 0) {
    console.error(errors[0].message);
    throw new Error(errors[0].message);
  }
  if (Watchlist) {
    return mapWatchlistResponseToCache(Watchlist);
  }
  return getDefaultResponse();
};
